"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sortString = sortString;
exports.sortNumber = sortNumber;
exports.sortStringNumber = sortStringNumber;
exports.sortDate = sortDate;
exports.sortDateString = sortDateString;
function sortString(a, b) {
    return a.localeCompare(b);
}
function sortNumber(a, b) {
    return a - b;
}
function sortStringNumber(a, b) {
    return +a - +b;
}
function sortDate(a, b) {
    return (a.getTime() || -Infinity) - (b.getTime() || -Infinity);
}
function sortDateString(a, b) {
    const date_a = new Date(a.split('.').reverse().join('.'));
    const date_b = new Date(b.split('.').reverse().join('.'));
    return sortDate(date_a, date_b);
}
